<template>
  <div style="background:#fff;">
    <div class="page_title flex_between">
      <span v-if="edit">编辑每日中药</span>
      <span v-else>添加每日中药</span>

      <el-button
        type="primary"
        style="width:92px;"
        size="medium"
        @click="back"
      >返回</el-button>
    </div>
    <div class="container">
      <div class="essay">
        <div style="margin-bottom:20px">
          <el-input
            v-model="title"
            placeholder="请输入标题"
            maxlength="30"
            show-word-limit
          ></el-input>
        </div>
        <div style="margin-bottom:20px">
          <el-input
            v-model="author"
            placeholder="请输入作者"
            maxlength="10"
            show-word-limit
          ></el-input>
        </div>
        <div style="margin-bottom:20px">
          <el-input
            v-model="summary"
            placeholder="请输入摘要"
            maxlength="100"
            show-word-limit
          ></el-input>
        </div>
        <div style="width:100%;height:100%;">
          <wangeditorNew
            ref="editorBox"
            @changeCheck="changeCheck"
            :margins="margins"
          />
        </div>
        <div class="btnbox">
          <div>
            <el-button
              type="primary"
              round
              style="width:100px;margin-right:5px"
              @click="submit"
            >保存</el-button>

            <el-button
              plain
              round
              style="width:100px"
              @click="back"
            >退出</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wangeditorNew from '../wangeditorNew';
import imgtext from '../../../api/imgtext';
export default {
  data() {
    return {
      title: '',
      author: '',
      summary: '',
      edit: false,
      margins: 1
    };
  },
  components: {
    wangeditorNew
  },
  methods: {
    //发布
    submit() {
      if (!this.title) {
        this.$message.error('请填写标题');
        return false;
      }
      if (!this.author) {
        this.$message.error('请填写作者');
        return false;
      }
      if (!this.summary) {
        this.$message.error('请填写摘要');
        return false;
      }
      let content = this.$refs.editorBox.editor.getHtml();
      if (!content) {
        this.$message.error('请填写内容');
        return false;
      }

      let data = {
        title: this.title,
        author: this.author,
        content: content,
        summary: this.summary,
        margins: this.margins,
        art_id: this.$route.query.art_id ? this.$route.query.art_id : 0
      };
      imgtext.saveDailyChineseMedicineInfo(data).then((res) => {
        if (res.code == 0) {
          this.$message.success('保存成功');
          this.back();
        }
      });
    },
    //获取
    getDetail() {
      let art_id = this.$route.query.art_id;
      imgtext.getDailyChineseMedicineInfo({ art_id }).then((res) => {
        if (res.code == 0) {
          let detail = res.data.info;
          this.title = detail.title;
          this.author = detail.author;
          this.summary = detail.summary;
          this.margins = detail.margins;
          if (detail.content) {
            this.setDesc(detail.content);
            this.edit = true;
          }
        }
      });
    },
    //往编辑器里插入数据
    setDesc(text) {
      this.$refs.editorBox.editor.setHtml(text);
    },
    //获取边距
    changeCheck(value) {
      this.margins = value;
    },
    back() {
      history.back();
    }
  },
  created() {
    this.margins = 1;
    if (this.$route.query.art_id) {
      this.getDetail();
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 120px);
  background: #fff;
}
.essay {
  width: 70%;
  margin: 20px auto 0;
}
.btnbox {
  width: 100%;
  height: 58px;
  border: solid 1px #cfcece;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 30px;
  box-sizing: border-box;
  background: #fff;
}
</style>
